import cn from 'classnames';
import React from 'react'
import { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { CSSTransition, SwitchTransition } from 'react-transition-group';
import { ONBOARDING_SKIP_HOME_EVENT, ONBOARDING_V2_SKIP_EMAIL_EVENT } from '../../../constants/analyticEvents';
import { pushEvent } from '../../../utilities/analytics';
import { isRtl } from '../../../utilities/helpers';
import { hideOnboarding, setCurrentStep } from '../onboardingSlice';
import { getWizardV2State } from '../wizardService';
import { isEntryFlow } from '../../../utilities/urlResolver';
import abTesting from '../../../services/abTesting';
import { getImage } from '../../../utilities/iconResolver';

const WizardNavbar = ({
  steps,
  slideDirection,
  stepName,
  currentStepIndex,
}) => {
  const dispatch = useDispatch();
  const { initiator, currentStep, stepNames } = useSelector(state => state.onboarding);
  // const currentStepIndex = stepNames.findIndex(step => step === currentStep);
  const rtl = isRtl();
  const stepsArray = useMemo(() => Array.from({ length: steps - 1 }, (_, i) => i + 1), [steps]);
  const { topLogo, smallLogo, navbarSkip, navbarBack } = getWizardV2State();

  const getNavbarState = () => {
    if (currentStep === 'welcome') return 'welcome';
    if (!['loading', 'loading-ai'].includes(currentStep)) return 'steps';
    return 'loading';
  }

  const navbarState = getNavbarState();
  const onBackClick = () => {
    if (initiator === 'customize' && currentStep === 'who') {
      dispatch(hideOnboarding());
    }

    if (currentStep === 'who' && abTesting.mobileHomepageScrollable) {
      document.querySelector('body').classList.add('mobile-wizzard-active-mobhp');
      document.querySelector('body').classList.remove('mobile-wizzard-active');
    }

    if (window.pr_welcome && currentStep === 'who') {
      document.dispatchEvent(new CustomEvent('pr_welcome_appReady', {}));
      const skeleton = document.querySelector('.skeleton-without-offers');
      skeleton?.classList?.remove('hide-skeleton');
    } else {
      dispatch(setCurrentStep(-1));
    }
  }

  const onHideOnboarding = () => {
    dispatch(setCurrentStep(1));
    pushEvent(ONBOARDING_SKIP_HOME_EVENT, { skipFrom: 'navbar' })
    pushEvent(ONBOARDING_V2_SKIP_EMAIL_EVENT, { skipFrom: 'navbar' })
  }

  const renderStepsNavbar = () => {
    const currentStep = stepNames[currentStepIndex];

    if (currentStep === 'who' && abTesting.wizardLandingStepAlternative) {
      return (
        <div className="wizard-navigation flex justify-center">
          <img src={getImage('HF-white-Logo.svg')} alt="" />
        </div>
      )
    }

    return (
      <div className="wizard-navigation">
        {<div className={cn('wizard-navigation__back', { invisible: (abTesting.wizardLandingStep === 'who' || abTesting.wizardLandingStep === 'who2' || abTesting.wizardLandingStepAlternative) && !isEntryFlow('link-presets-welcome') && currentStep === 'who' })} onClick={onBackClick}>
          {rtl ? (
            <i className="ri-arrow-right-s-line" />
          ) : (
            <i className="ri-arrow-left-s-line" />
          )}
          <span>{navbarBack}</span>
        </div>}
        <div className="wizard-bullet-navigation">
          {stepsArray.map(step => (
            <span key={step} className={cn('wizard-bullet-navigation__item', { 'wizard-bullet-navigation__item--active': currentStepIndex === step })} />
          ))}
        </div>
        {stepName === 'email' && <div className="wizard-navigation__skip" onClick={onHideOnboarding}>{navbarSkip}</div>}
      </div>
    )
  }

  return (
    <div className="wizard-navbar">
      <SwitchTransition mode="out-in">
        <CSSTransition
          key={navbarState}
          classNames={slideDirection}
          timeout={{
            appear: 500,
            enter: 500,
            exit: 0,
          }}
          addEndListener={(node, done) => {node.addEventListener('transitionend', done, false)}}
        >
          <>
            {currentStep === 'welcome' && (
              <img src={topLogo} alt="Logo" />
            )}
            {navbarState === 'steps' && renderStepsNavbar()}
            {['loading', 'loading-ai'].includes(currentStep) && (
              <div className="text-center"><img src={smallLogo} alt="Logo" /></div>
            )}
          </>
        </CSSTransition>
      </SwitchTransition>
    </div>
  )
}

export default WizardNavbar
